
$(function(){
    let page_address = location.href
    link_active();

    if (page_address.match("mailpost")) {
        error_message();
    } else {
        mypageRadioCheck();
        area_width();
    }
});

// メール投稿申請のバリデーションメッセージ表示
function error_message() {
    let error_message = $(".mail_post_message").text();
    if (error_message != "") {
        $(".validation_error").addClass("error_message alert alert-warning");
    }
}


// プロフィール画像を変更ボタンを押す(1)
$('.btn_update_image').on('click',function () {
    $('.image_update_btn').trigger('click');
});

// プロフィール画像を変更ボタンを押す(2)
$(".image_update_btn").on('change',function () {
    readURL(this);
});

// link active処理 
$('.tab_transition').on('click',function () {
    $('.tab_transition').removeClass('active');
    $(this).addClass('active');
});

// サイドバーのマイページをアクティブに設定
function link_active() {
    $('.menu_active').removeClass('link_active');
    $('.mypage_link').addClass('link_active');
}

// 登録情報管理リンクを押せないように指定
$('.active_link').on('click', function () {
    return false;
});

// 変更ボタンを押す
$('.update_btn').on('click',function () {    
        $('.update_btn').remove();
        $('.image_update_btn').css('display', 'block');
        $('.human_introduction').css({
            'resize': 'vertical'
        });
        $('.human_id').css({
            'background-color': '#ffffff',
            'border': '0'
        });
        $('#user_house_flag_0').prop('disabled', false);
        $('#user_house_flag_1').prop('disabled', false);

        $('.display_name_value').remove();
        $('.house_area_value').remove();
        $('.introduction_value').remove();
        $('.website_value').remove();
  
        $('.form-control').removeClass('d-none');
        $('.btn_update_image').removeClass('d-none');
        $('.btn_edit_register').removeClass('d-none');
    
});

// プロフィール画像のpreview表示
function setImageFromFile(input, expression) {
    if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
            $(expression).attr('src', e.target.result);
        }
        reader.readAsDataURL(input.files[0]);
    }
}

// プロフィール画像のpreview表示
function readURL(input) {
    if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
            $('#preview_images').attr('src', e.target.result);
        }
        reader.readAsDataURL(input.files[0]);
    }
    $('.img_profile').addClass('d-none');
    $('.preview_photo').removeClass('d-none');
    $('.preview_photo').addClass('img_profile');
}

// DBからお住まいの地域のステータスのデータを取得してラジオボタンが選択される
function mypageRadioCheck() {

    let human_flag = $('#human_flag').val();
    let public_flag = $('#user_house_flag_0').val();

    
    if (human_flag == public_flag) {
        $('#user_house_flag_0').prop('checked', true);
        $('#user_house_flag_1').prop('disabled', true);
    } else {
        $('#user_house_flag_1').prop('checked', true);
        $('#user_house_flag_0').prop('disabled', true);
    }
}

// それぞれの登録情報文字が長い場合、スクロールで表示
function area_width() {
    $('.area_width').each(function (index, elmTag) {
        if ($(elmTag).prop('scrollHeight') > $(elmTag).height()) {
            $(elmTag).css('line-height', '1.5');
        }
    });
    
    if ($('.introduction_width').prop('scrollHeight') > $('.introduction_width').height()) {
        $('.introduction_width').css('overflow', 'hidden');
        $('.introduction_width').css('overflow-y', 'scroll');
    }

    if ($('.other_introduction_width').prop('scrollHeight') > $('.introduction_width').height()) {
        $('.other_introduction_width').css('overflow', 'hidden');
        $('.other_introduction_width').css('overflow-y', 'scroll');
    }


    if ($('.display_name_width').prop('scrollHeight') > $('.display_name_width').height()) {
        $('.display_name_width').css('line-height', '1.5');
    }

    $('.site_width').each(function (index, elmTag) {
        if ($(elmTag).prop('scrollHeight') > $('.site_width').height()) {
            $(elmTag).css('line-height', '1.5');
        }
    });

    if ($('.id_width').prop('scrollHeight') > $('.id_width').height()) {
        $('.id_width').css('line-height', '1.5');
    }

    if ($('.other_site_width').prop('scrollHeight') > $('.other_site_width').height()) {
        $('.other_site_width').css('line-height', '1.5');
    }

    if ($('.other_id_width').prop('scrollHeight') > $('.other_id_width').height()) {
        $('.other_id_width').css('line-height', '1.5');
    }

    if ($('.other_house_area_width').prop('scrollHeight') > $('.other_house_area_width').height()) {
        $('.other_house_area_width').css('line-height', '1.5');
    }
}



